const state = {
    subscriber: /* JSON.parse(localStorage.getItem('me_info_')) */ null,
    first_login_configs: {
        subscribed_conso_products_notif: false,
        subscribed_conso_internet_notif: false,
        already_guided: null,
    },
    balance: localStorage.getItem('b_l'),
    bill_details: null,
    subscriptions: null,
    current_sim_details: null,
    bundles_list: {},
    puk: null,
    bundles: null,
    consommations: [],
    bill_internet: [],
    consommations_internet: [],
    current_filter: {
        start: '',
        end: '',
        label: ''
    },
    download_produits: [],
    business_account: {
        account_number: '',
        account_details: {
        },
        payment_status_datas: {
            initiated: {
                message: "Paiement inité avec succès",
                icon: "mdi-alert-circle-check",
                status: "pending",
            },
            pending: {
                message: "Paiement inité avec succès. <br> Si vous avez MTN mobile money sur ce numéro, <br> vous recevrez une demande de paiement mobile money <br> pour procéder au paiement.",
                icon: "mdi-cash",
                status: "pending",
            },
            successful: {
                message: "Paiement effectué avec succès.",
                icon: "mdi-checkbox-marked-circle",
                status: "successful",
            },
            already_queued: {
                message: "",
                icon: "mdi-cancel",
                status: "already_queued",
            },
            failed: {
                message:
                    "Paiement non effectué, veuillez vérifier votre solde momo et réessayer ou contacter notre service client pour avoir de l'aide.",
                icon: "mdi-alert-circle",
                status: "failed",
            },
        },
    },

};
const getters = {

};
const actions = {

};
const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};